import { MENU } from "../data/site";

const Item = ({ item }) => (
  <li className="py-4" data-testid={`menu-item-${item.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
    <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
      <h4 className="font-heading text-base font-bold text-charcoal sm:text-lg">
        {item.name}
      </h4>
      {item.tag && (
        <span className="rounded-full bg-bumbu-light px-2.5 py-0.5 font-mono text-[10px] font-bold uppercase tracking-wider text-bumbu-deep">
          {item.tag}
        </span>
      )}
      <span aria-hidden="true" className="hidden flex-1 border-b-2 border-dotted border-amber-900/30 sm:block" />
      {item.price && (
        <span className="ml-auto font-mono text-base font-bold text-bawang sm:ml-0 sm:text-lg">
          {item.price}
        </span>
      )}
    </div>
    <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-charcoal-muted">
      {item.desc}
    </p>
  </li>
);

export const MenuSheet = () => (
  <div
    data-testid="menu-sheet"
    className="relative overflow-visible rounded-lg border border-amber-900/15 bg-white shadow-[0_18px_50px_-20px_rgba(120,72,10,0.35)]"
  >
    <div className="flex items-center justify-between rounded-t-lg bg-charcoal px-6 py-4 sm:px-10">
      <span className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-canvas">
        Selembar Menu
      </span>
      <span className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-bumbu-bright">
        Bu Iyin
      </span>
    </div>

    <div className="space-y-10 px-6 py-8 sm:px-10 sm:py-12">
      {MENU.map((cat) => (
        <section key={cat.category}>
          <div className="flex items-baseline gap-4">
            <h3 className="font-heading text-xl font-extrabold tracking-tight text-bumbu-deep sm:text-2xl">
              {cat.category}
            </h3>
            <span aria-hidden="true" className="flex-1 border-t-2 border-dashed border-amber-900/25" />
          </div>
          {cat.note && (
            <p className="mt-1.5 text-sm italic text-charcoal-muted">{cat.note}</p>
          )}
          <ul className="mt-2 divide-y divide-dashed divide-amber-900/15">
            {cat.items.map((item) => (
              <Item key={item.name} item={item} />
            ))}
          </ul>
        </section>
      ))}
    </div>

    <div className="px-2 pb-2">
      <div className="ticket-perf" aria-hidden="true" />
      <p className="px-4 pb-4 pt-4 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-charcoal-muted">
        Terima kasih sudah antre
      </p>
    </div>
  </div>
);
